"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferPalletRerouteReason = void 0;
var TransferPalletRerouteReason;
(function (TransferPalletRerouteReason) {
    TransferPalletRerouteReason["CONSOLIDATED_FOR_SAVINGS"] = "CONSOLIDATED_FOR_SAVINGS";
    TransferPalletRerouteReason["CAPACITY_AT_DOWNSTREAM_FC"] = "CAPACITY_AT_DOWNSTREAM_FC";
    TransferPalletRerouteReason["FC_NO_LONGER_IN_POOL"] = "FC_NO_LONGER_IN_POOL";
    TransferPalletRerouteReason["ARRIVED_AT_UNEXPECTED_FC"] = "ARRIVED_AT_UNEXPECTED_FC";
    TransferPalletRerouteReason["SUPPORT_FC_RAMPUP"] = "SUPPORT_FC_RAMPUP";
    TransferPalletRerouteReason["LATE_BIND_PALLET"] = "LATE_BIND_PALLET";
    TransferPalletRerouteReason["OTHER"] = "OTHER";
})(TransferPalletRerouteReason = exports.TransferPalletRerouteReason || (exports.TransferPalletRerouteReason = {}));
//# sourceMappingURL=TransferPalletRerouteReason.js.map